'use client'

import React from 'react'
import { Stack } from '@mantine/core'
import { useMessageCenterFeatureEnabled } from '@/contexts/AccountDashboardFeatureContext'
import { PageCategory } from '@/types/enums/StoreTypes'
import { MenuRow } from './MenuRow'
import { companyItems, getCareItems, getAccountDashboardAccountItems } from './menuData'
import { SectionLabel } from './SectionLabel'

interface TopLevelMenuProps {
    isLoggedIn: boolean | undefined
    onItemClick: (e: React.MouseEvent, item: PageCategory) => void
    onAccountItemClick: (item: PageCategory) => void
    onSignOut: () => void
}

export function TopLevelMenu({ isLoggedIn, onItemClick, onAccountItemClick, onSignOut }: TopLevelMenuProps) {
    const messageCenterEnabled = useMessageCenterFeatureEnabled()
    const loggedInAccountItems = getAccountDashboardAccountItems(messageCenterEnabled)

    return (
        <>
            <MenuSection label="Get care">
                {getCareItems.map((item) => (
                    <TopLevelRow key={item.slug} item={item} onClick={onItemClick} />
                ))}
            </MenuSection>
            {isLoggedIn && (
                <MenuSection label="Your account">
                    {loggedInAccountItems.map((item) => (
                        <MenuRow
                            key={item.slug}
                            name={item.name}
                            href={item.href}
                            hasChevron={false}
                            onClick={() => onAccountItemClick(item)}
                        />
                    ))}
                    <MenuRow name="Sign out" hasChevron={false} onClick={onSignOut} />
                </MenuSection>
            )}
            <MenuSection label="General Medicine">
                {companyItems.map((item) => (
                    <TopLevelRow key={item.slug} item={item} onClick={onItemClick} />
                ))}
            </MenuSection>
        </>
    )
}

function MenuSection({ label, children }: { label: string; children: React.ReactNode }) {
    return (
        <Stack gap={16}>
            <SectionLabel>{label}</SectionLabel>
            {children}
        </Stack>
    )
}

function TopLevelRow({
    item,
    onClick,
}: {
    item: PageCategory
    onClick: (e: React.MouseEvent, item: PageCategory) => void
}) {
    return (
        <MenuRow
            name={item.name}
            href={item.href}
            hasChevron={!!item.overrideSection}
            showGenAiIcon={item.slug === 'general-ai'}
            onClick={(e) => onClick(e, item)}
        />
    )
}
